import {
	Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, SimpleChange,
	ChangeDetectorRef,
	EventEmitter,
	Output,
	ViewChild
} from '@angular/core';
import { MessageService } from 'base';
import { TopoMap } from 'topomap/dtos/topology/TopoMap';
import { DeviceNode } from 'topomap/dtos/topology/DeviceNode';
import { Table } from 'primeng/table';


@Component({
    selector: 'map-search',
	templateUrl: './map-search.component.html',
    styleUrls: ['./map-search.component.scss']
})
export class MapSearchComponent implements OnInit, OnDestroy {

	@Input()
	public visible: boolean;

	@Input()
	public map: TopoMap;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public deviceSelected: EventEmitter<DeviceNode>;

	@ViewChild('tt', { static: true })
	public table: Table;

	public cols: any[];
	public deviceList: DeviceNode[];
	public selectedDevice: DeviceNode;
	public searchText: string;

	constructor(
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef) {

		this.visible = false;
		this.map = null;
		this.visibleChange = new EventEmitter<boolean>();
		this.deviceSelected = new EventEmitter<DeviceNode>();

		this.cols = [
			{ field: 'deviceName', header: 'Device Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
			{ field: 'ipAddress', header: 'IP Address', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
			{ field: 'macAddress', header: 'MAC Address', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" },
		];

		this.deviceList = [];
		this.selectedDevice = null;
		this.searchText = "";
    }

	public doCustomSort(event): void {
	}

	public ngOnInit() {
		return;
	}

	public ngOnDestroy(): void {
		return;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["map"]) {
			if (this.map) {
				this.deviceList = this.map.deviceNodes;
			}
			else {
				this.deviceList = [];
			}
		}
		if (changes["visible"]) {
			this.searchText = "";
			this.selectedDevice = null;
			this.table.filterGlobal(this.searchText, 'contains');
		}
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public get enableOkButton(): boolean {
		return !!this.selectedDevice;
	}

	public onDeviceSelected(device: DeviceNode): void {
		this.hide();
		this.deviceSelected.emit(device);	}

	public onDialogHide(): void {
		this.hide();
	}

	public onOkClicked(): void {
		this.hide();
		this.deviceSelected.emit(this.selectedDevice);
	}

	public onCancelClicked(): void {
		this.hide();
	}

}
